;(function(window, document, undefined) {
  'use strict';
var Deferred = (function(){
  function Deferred(){
    var def = this;
    /**
     * @instance
     * @memberof Flybits.Deferred
     * @member {external:Promise} promise Instance of an ES6 Promise to be fulfilled.
     */
    this.promise = new Promise(function(resolve,reject){
      /**
       * @instance
       * @memberof Flybits.Deferred
       * @member {function} resolve Callback to be invoked when the asychronous task that initiated the promise is successfully completed.
       */
      def.resolve = resolve;
      /**
       * @instance
       * @memberof Flybits.Deferred
       * @member {function} reject Callback to be invoked when the asychronous task that initiated the promise has failed to complete successfully.
       */
      def.reject = reject;
    });

    this.then = this.promise.then.bind(this.promise);
    this.catch = this.promise.catch.bind(this.promise);
  }

  Deferred.settlePromises = Deferred.prototype.settlePromises = function(promisesArr){
    var reflectedArr = promisesArr.map(function(promise){
      return promise.then(function(successResult){
        return {
          result: successResult,
          status: 'resolved'
        };
      },function(errorResult){
        return {
          result: errorResult,
          status: 'rejected'
        };
      });
    });
    return Promise.all(reflectedArr);  
  };

  return Deferred;
})();

var Validation = (function(){
  function Validation(){
    this.state = true;
    this.errors = [];

    this.stacktrace = "";

    this.setStackTrace();
  }

  Validation.prototype = {
    addError: function(header,message,detailsObj){
      this.state = false;
      var retObj = {
        header: header,
        message: message
      };
      if(detailsObj){
        retObj.context = detailsObj.context;
        retObj.code = detailsObj.code;
        retObj.serverCode = detailsObj.serverCode;
      }
      this.errors.push(retObj);

      return this;
    },
    firstError: function(){
      if(this.errors.length > 0){
        return this.errors[0];
      }
      return null;
    },
    merge: function(validation){
      Array.prototype.push.apply(this.errors,validation.errors);
      this.state = this.errors.length < 1;

      return this;
    },
    setStackTrace: function(){
      var flyError = new Error();
      flyError.name = "FlybitsError";
      this.stacktrace = flyError.stack;
      if(this.stacktrace){
        this.stacktrace = this.stacktrace.split('\n').filter(function(str){
          return str.indexOf('Validation') < 0;
        }).join('\n');
      }
      return this;
    },
    toJSON: function(){
      return {
        state: this.state,
        errors: this.errors,
        stacktrace: this.stacktrace
      };
    }
  };

  Validation.prototype.type = Validation.type = {};
  Validation.prototype.type.MALFORMED = Validation.type.MALFORMED = 1000;
  Validation.prototype.type.INVALIDARG = Validation.type.INVALIDARG = 1001;
  Validation.prototype.type.MISSINGARG = Validation.type.MISSINGARG = 1002;
  Validation.prototype.type.NOTFOUND = Validation.type.NOTFOUND = 1003;
  Validation.prototype.type.CONNECTIONERROR = Validation.type.CONNECTIONERROR = 1004;
  Validation.prototype.type.UNAUTHENTICATED = Validation.type.UNAUTHENTICATED = 1005;
  Validation.prototype.type.RETRIEVALERROR = Validation.type.RETRIEVALERROR = 1006;
  Validation.prototype.type.NOTSUPPORTED = Validation.type.NOTSUPPORTED = 1007;
  Validation.prototype.type.UNEXPECTED = Validation.type.UNEXPECTED = 1008;

  return Validation;
})();

/**
 * @classdesc Base class from which all core Flybits models are extended.
 * @class
 * @param {Object} serverObj Raw Flybits core model `Object` directly from API.
 */
 var BaseModel = (function(){
  var BaseModel = function(serverObj){
    /**
     * @instance
     * @memberof BaseModel
     * @member {string} id Parsed ID of the Flybits core model.
     */
    this.id;

    if(serverObj && serverObj.id){
      this.id = serverObj.id;
    }
  };

  BaseModel.prototype.constructor = BaseModel;

  BaseModel.prototype.reqKeys = {
    id: 'id'
  };

  return BaseModel;
})();

var Path = (function(){
  function Path(){
    this.nodes = [];
  };

  Path.prototype.getNode = function(className){
    return this.nodes.filter(function(obj){
      return Flybits.util.Obj.functionName(obj.constructor) === className;
    })[0];
  };

  Path.prototype.append = function(obj){
    this.nodes.push(obj);
    return this;
  };

  Path.prototype.serialize = function(){
    var pathStr = "";
    for(var i = 0; i < this.nodes.length; i++){
      pathStr += '/' + this.nodes[i]._pathName;
      if(this.nodes[i].id){
        pathStr += '/' + this.nodes[i].id;
      }
    }
    
    return pathStr;
  };

  return Path;
})();

var Zone = (function(){
  function Zone(json){
    this.fromJSON(json);
  };

  Zone.prototype = {
    fromJSON: function(json){
      json = json || {};
      this.id = json.id || App.util.Obj.guid();
      this.name = json.name || 'Zone ' + this.id.slice(0, 4);
      this.modules = json.modules?json.modules.map(function(m){
        return new Module(m);
      }):[];

      return this;
    },
    toJSON: function(){
      var retObj = {
        name: this.name,
        modules: this.modules.map(function(m){
          return m.toJSON();
        })
      };

      if(this.id){
        retObj.id = this.id;
      }

      return retObj;
    }
  };

  return Zone;
})();
var Module = (function(){
  function Module(json){
    this.fromJSON(json);
  };

  Module.prototype = {
    hasDefaultLayout: function(){
      return this._layoutType.key === 'default'
    },
    fromJSON: function(json){
      json = json || {};
      this.id = json.id || App.util.Obj.guid();
      this.name = json.name || 'Module ' + this.id.slice(0,4);
      var query = new URLSearchParams(json.query);
      this.paging  = {};
      
      var limitStr = query.get('limit');
      if(limitStr){
        this.paging.limit = +limitStr;
      }

      if(this.paging.limit){
        this._hasContentLimits = true;
      }

      var labelsFormulaStr = query.get('labelsFormula');
      this.labels = labelsFormulaStr?labelsFormulaStr.replace('(','').replace(')','').split(';'):[];

      this.layout = json.layout;
      this.layoutStr = json.layoutStr;
      if(this.layoutStr){
        this._layoutType = {key:'custom'};
      } else{
        this._layoutType = {key:'default'}
      }

      this.style = json.style;
      this.styleStr = json.styleStr;

      return this;
    },
    toJSON: function(){
      if(this._layoutType.key === 'default'){
        this.layoutStr = '';
      } else if(this._layoutType.key === 'custom'){
        this.layout = '';
      }

      if(!this._hasContentLimits){
        delete this.paging.limit;
      }

      var retObj = {
        name: this.name,
        layout: this.layout,
        layoutStr: this.layoutStr,
        style: this.style,
        styleStr: this.styleStr
      };

      if(this.id){
        retObj.id = this.id;
      }


      var query = new URLSearchParams();
      query.append('data', true);

      if(this.labels.length){
        query.append('labelsFormula', '('+this.labels.join(';')+')');
      }

      if(this.paging.limit){
        query.append('limit', this.paging.limit);
      }

      retObj.query = query.toString();

      return retObj;
    }
  };

  return Module;
})();
var Content = ( function(){
  var ApiUtil = Flybits.util.Api;

  /**
   * @typedef LocalizedObject
   * @memberof Flybits.Content
   * @type Object
   * @property {string} name Name of the Content instance.
   * @property {string} description Description of the Content instance.
   */

  function Content( serverObj ){
    BaseModel.call( this, serverObj );
    if( serverObj ){
      this.fromJSON( serverObj );
    }
  }

  Content.prototype = Object.create( BaseModel.prototype );
  Content.prototype.constructor = Content;

  Content.prototype.types = Content.types = {
    DEFAULT: 'default',
    SURVEY: 'SurveyQuestions'
  };
  Content.prototype._pathName = Content._pathName = 'content/instances';

  Content.prototype.reqKeys = Content.reqKeys = {
    name: 'name',
    description: 'description',
    createdDate: 'createdAt',
    lastModifiedDate: 'modifiedAt',
    id: 'id'
  };

  /***** Localizable function overloading *****/
  Content.prototype._fromLocaleJSON = function( serverObj ) {
    var retObj = {
      name: serverObj.name,
      description: serverObj.description
    };

    return retObj;
  };

  Content.prototype._toLocaleJSON = function ( appObj ) {
    var retObj = {
      name: appObj.name,
      description: appObj.description
    };

    return retObj;
  };

  Content.prototype.parseContents = function(serverObj){
    var paging = ApiUtil.parsePaging( serverObj );
    var contentObj = this;
    
    var allContentData = serverObj.data.map( function(obj){
      var routePath = new Path().append(contentObj);
      try{
        return new Flybits.ContentData( obj, routePath );
      } catch(e){
        console.error(e);
        throw new Validation().addError("Parse Failed","Failed to parse Content data model.",{
          code: Validation.type.MALFORMED,
          context: obj
        });
      }
    });

    return {
      result: allContentData,
      nextPageFn: ApiUtil.createNextPageCall( Flybits.api.ContentData.getAll, {
        contentID: contentObj.id
      }, paging )
    };
  };

  /**
   * Retrieve the data from the Content model instance.
   * @memberof Flybits.Content
   * @instance
   * @function getData
   * @return {external:Promise<Object,Flybits.Validation>} Promise that resolves with the Content instance's JSON payload object.
   */
  Content.prototype.getData = function(){
    var obj = this;
    if(this.data && this.data.result && this.data.result.length > 0){
      return Promise.resolve(this.data.result[0].payload);
    } else{
      var def = new Flybits.Deferred();
      Flybits.api.ContentData.getAll({
        contentID: this.id
      }).then(function(respObj){
        if(respObj && respObj.result && respObj.result.length > 0){
          obj.data = respObj;
          def.resolve(respObj.result[0].payload);
        } else{
          def.resolve();
        }
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    }
  };

  /***** Serializable function overloading *****/
  Content.prototype.fromJSON = function(serverObj){
    var obj = this;
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {string} id - id value of the content instance.
     */
    obj.id = serverObj.id;
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {string} tenantID - id value of the tenant(project) of instance
     */
    obj.tenantID = serverObj.tenantId;
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {string} templateID - id value of the content template of the fetched content instance.
     */
    obj.templateID = serverObj.templateId;
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {string} type - content template type from which this instance was created from.
     */
    obj.type = serverObj.templateType || Content.types.DEFAULT;
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {string} iconURL - URL of the icon image associated with this content instance.
     */
    obj.iconURL = serverObj.iconUrl;
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {Date} createdDate - Date of model creation.
     */
    obj.createdDate = serverObj.createdAt? new Date(serverObj.createdAt*1000):null;
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {Date} lastModifiedDate - Date of last modification of model.
     */
    obj.lastModifiedDate = serverObj.modifiedAt? new Date(serverObj.modifiedAt*1000):null;
    /**
     * @instance
     * @memberof Flybits.Content
     * @see Flybits.Content.LocalizedObject
     * @member {Object} locales - Map of available locale keys to {@link Flybits.Content.LocalizedObject} objects containing information.
     * @example
     * { 
     *   en: {
     *     name: 'Falafel',
     *     description: 'Falafel is good'
     *   },
     *   fr: {
     *     name: 'Falafel',
     *     description: 'Falafel est bon'
     *   }
     * }
     */
    obj.locales = {};

    var localeKeys = serverObj.localizations ? Object.keys(serverObj.localizations) : [];
    localeKeys.forEach( function( key ) {
      obj.locales[key] = obj._fromLocaleJSON( serverObj.localizations[key] );
    });

    obj.name = obj.locales.en?obj.locales.en.name:'';
    obj.description = obj.locales.en?obj.locales.en.description:'';

    // if( localeKeys.length > 0 && this.defaultLang ) {
    //   this.defaultLocaleObj = this.locales[ this.defaultLang ];
    // }
    /**
     * @instance
     * @memberof Flybits.Content
     * @member {string} 
     */
    obj.linkedFields = serverObj.linkedFields;

    /**
     * @instance
     * @memberof Flybits.Content
     * @member {string[]}
     */
    obj.labels = serverObj.labels || [];

    obj.data = serverObj.content? this.parseContents(serverObj.content):undefined;

    obj.previewUI = serverObj.metadata?serverObj.metadata.previewUI:{
      styleStr: '',
      uiTemplate: '',
      style: ''
    };
  };

  Content.prototype.toJSON = function(){
    var obj = this;
    
    var retObj = {
      iconUrl: obj.iconURL,
      localizations: {},
      labels: obj.labels,
    };

    if(obj.createdDate){
      retObj.createdAt = Math.round(obj.createdDate.getTime()/1000);
    }
    if(obj.lastModifiedDate){
      retObj.modifiedAt = Math.round(obj.lastModifiedDate.getTime()/1000);
    }

    if( Object.keys( obj.locales ).length > 0 ) {
      var localeKeys = Object.keys( obj.locales );
      localeKeys.forEach( function( key ) {
        retObj.localizations[key] = obj._toLocaleJSON( obj.locales[key] );
      });
    }

    /* id rendering: thrown in for just safety purpose
     * id validations(content instance, content template, tenant) moved to the content API
     * id is not passed in the body of JSON (PUT, POST) requests anymore (Part of Header and URL)
     */
    if( obj.id ) {
      retObj.id = obj.id;
    }

    if( obj.tenantID ) {
      retObj.tenantId = obj.tenantID;
    }

    if( obj.templateID ) {
      retObj.templateId = obj.templateID;
    }

    if( obj.type ){
      retObj.templateType = obj.type;
    }

    if(obj.metadata){
      retObj.metadata = obj.metadata;
    } else{
      retObj.metadata = {};
    }

    retObj.metadata.previewUI = obj.previewUI;
    
    
    return retObj;
  };

  Content.getInstance = function(serverObj){
    var hasQuestions = serverObj.content && serverObj.content.data && serverObj.content.data.length && serverObj.content.data[0].questions;

    if((serverObj.templateType === Content.types.SURVEY && serverObj.surveyMetadata) || hasQuestions){
      return new Flybits.Survey(serverObj);
    } else{
      return new Content(serverObj);
    }
  };

  return Content;
})();
var LoadingView = Vue.extend({
  template:'#view-loading',
});
Vue.component('loading-view',LoadingView);
var LoaderBar = Vue.extend({
  template:'#loader-bar',
});
Vue.component('loader-bar',LoaderBar);

var HeaderBar = (function(){
  return Vue.extend({
    template:'#header-bar',
    props: {
      title: {
        default: 'Concierge Manager'
      }
    },
    data: function(){
      return {
        logoURL: 'images/logoIcon.svg',
        isAdmin: App.store.state.user.isAdmin
      };
    },
    computed: {
      userInitials: function(){
        var str = '';
        if(App.store.state.user.user && App.store.state.user.user.firstName){
          str += App.store.state.user.user.firstName.charAt(0);
        }
        if(App.store.state.user.user && App.store.state.user.user.lastName){
          str += App.store.state.user.user.lastName.charAt(0);
        }
        return str.toUpperCase();
      },
      userFullName: function(){
        if(App.store.state.user.user){
          return  App.store.state.user.user.firstName + ' ' +
                  App.store.state.user.user.lastName;
        }
        return '';
      }
    },
    methods: {
      logout: function(){
        App.store.dispatch('user/logout');
        App.router.replace({
          name: 'login'
        });
      },
      gotoSettings: function(){
        App.router.push({
          name: 'settings'
        });
      }
    },
    mounted: function(){
    }
  });
})();
Vue.component('header-bar',HeaderBar);

var EditableDisplayfield = (function(){
  return Vue.extend({
    template:'#editable-displayfield',
    props: ['value', 'placeholder'],
    data: function(){
      return {
        proxyVal: '',

      }
    },
    watch: {
      value: function(newVal, oldVal){
        if(this.proxyVal !== newVal){
          this.proxyVal = newVal;
        }
      },
      proxyVal: function(newVal, oldVal){
        if(this.value !== newVal){
          this.$emit('input', newVal);
          this.resize();
        }
      }
    },
    methods: {
      focusEdit: function(){
        this.$refs.textedit.focus();
      },
      resize: function(){
        this.$refs.textedit.style.width = (this.proxyVal.length + 5) + 'ch';
      }
    },
    mounted: function(){
      if(this.value){
        var view = this;
        this.proxyVal = this.value;
        this.resize();
      }
    }
  });
})();
Vue.component('editable-displayfield',EditableDisplayfield);

var TextToggle = (function(){
  return Vue.extend({
    template:'#text-toggle',
    props: {
      options: {
        type: Array,
        default: function(){
          return [{
            label: 'Off',
            key: 'off'
          },{
            label: 'On',
            key: 'on'
          }]
        }
      },
      value: {
        type: Object
      }
    },
    methods: {
      isSelected: function(opt){
        return opt.key === this.value.key;
      },
      select: function(opt){
        this.$emit('input', opt);
      }
    }
  });
})();
Vue.component('text-toggle',TextToggle);

var ToggleView = Vue.extend({
  template:'#toggle-view',
  props:['value','label','inverted'],
  methods:{
    toggle:function(){
      this.$emit('input',!this.value);
    }
  }
});
Vue.component('toggle-view',ToggleView);
var LabelPicker = (function(){
  return Vue.extend({
    template:'#label-picker',
    props: {
      value: {
        type: Array
      },
      available: {
        type: Array,
        default: function(){return[];}
      },
      onlyAvailable: {
        type: Boolean,
        default: false
      }
    },
    data: function(){
      return {
        tmpNewLabel: '',
        inputMode: false,
        removeLastMode: false
      };
    },
    watch: {
      tmpNewLabel: function(newVal, oldVal){
        this.removeLastMode = false;
      }
    },
    methods: {
      addLabel: function(str){
        var view = this;
        var inputLabel = this.tmpNewLabel || str;

        if(inputLabel){
          this.value.push(inputLabel);
          this.$emit('input', this.value);
          this.tmpNewLabel = '';
          Vue.nextTick(function(){
            view.removeLastMode = true;
          });
        }
      },
      removeLabel: function(str){
        App.util.Obj.removeObject(this.value, str);
        this.$emit('input', this.value);
      },
      removeLastLabel: function(){
        if(!this.tmpNewLabel && this.removeLastMode){
          this.value.pop();
          this.$emit('input', this.value);
        } else if(!this.tmpNewLabel && !this.removeLastMode){
          this.removeLastMode = true;
        }
      },
      toggleInputMode: function(){
        var view = this;
        if(this.onlyAvailable){
          return;
        }

        this.inputMode = !this.inputMode;
        if(!this.inputMode){
          this.tmpNewLabel = '';
        } else{
          Vue.nextTick(function(){
            view.$refs.labelinput.focus();
          })
        }
      }
    }
  });
})();
Vue.component('label-picker',LabelPicker);

var PhonePreview = (function(){
  
  var stripContent = function(content){
    var data = content.data.result[0].toJSON();
    App.util.Content.flattenLocales(data);
    var retObj = {
      id: content.id,
      data: data,
      uiTemplate: content.previewUI.uiTemplate,
      style: content.previewUI.style,
      styleStr: content.previewUI.styleStr
    };
    return retObj;
  };

  var setInject = function(iframe, payload){
    var def = new Deferred();
    var callback = function(){
      iframe.contentWindow.postMessage(payload, '*');
      def.resolve();
    };

    iframe.addEventListener('load', callback);
    iframe.setAttribute('src', App.store.state.config.res.ZONEAPP);
    def.promise.then(function(){
      iframe.removeEventListener('load', callback);
    });
  };

  return Vue.extend({
    template:'#phone-preview',
    props: ['zone','module', 'changeHash'],
    data: function(){
      return {
        timer: null,
        time: null,
      };
    },
    computed: {
      timeStr: function(){
        var retStr = '';
  
        if(this.time){
          retStr = App.util.Obj.zero2Pad(this.time.getHours()) + ':' + App.util.Obj.zero2Pad(this.time.getMinutes());
        }
  
        return retStr;
      },
      zonePayload: function(){
        if(this.zone){
          var payload = {
            name: this.zone.name,
            containers: this.zone.modules.map(function(module){
              return {
                name: module.name,
                layoutStr: module.layoutStr,
                layout: module.layout,
                style: module.style,
                styleStr: module.styleStr,
                query: module.toJSON().query,
                content: App.store.getters['content/getContentByLabels'](module.labels).map(function(c){
                  return stripContent(c);
                })
              }
            })
          };
          
          return payload;
        }
        return;
      },
      modulePayload: function(){
        if(this.module){
          var payload = {
            name: 'tmp' + App.util.Obj.guid(1),
            containers: [{
              name: this.module.name,
              layoutStr: this.module.layoutStr,
              layout: this.module.layout,
              style: this.module.style,
              styleStr: this.module.styleStr,
              query: this.module.toJSON().query,
              content: App.store.getters['content/getContentByLabels'](this.module.labels).map(function(c){
                return stripContent(c);
              })
            }]
          }
          return payload;
        }
        return;
      }
    },
    watch: {
      changeHash: function(newVal, oldVal){
        console.log('> newVal', newVal);
        var vm = this;
        Vue.nextTick(function(){
          vm.loadZone();
        });
      }
    },
    methods: {
      startClock: function(){
        var view = this;
        this.endClock();
        console.log('> start clock');
        view.time = new Date();
        this.timer = setInterval(function(){
          view.time = new Date();
        }, 60000);
      },
      endClock: function(){
        clearInterval(this.timer);
        this.timer = null;
      },
      loadZone: function(){
        var view = this;
        var iframe = this.$refs.zoneframe;
        
        if(this.zone){
          setInject(iframe, this.zonePayload);
        } else if(this.module){
          setInject(iframe, this.modulePayload);
        }
      }
    },
    mounted: function(){
      this.startClock();
    }
  });
})();
Vue.component('phone-preview',PhonePreview);

var CardPlaceholder = (function(){
  return Vue.extend({
    template:'#card-placeholder',
    data: function(){
      return {
        block: 0
      };
    },
    methods: {
      /** inclusive */
      getRandomInt: function(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      } 
    },
    mounted: function(){
      this.block = this.getRandomInt(0,3);
    }
  });
})();
Vue.component('card-placeholder',CardPlaceholder);

var LayoutEditor = (function(){
  var BASIC = {label:'Basic', key: 'basic'};
  var ADVANCED = {label: 'Advanced', key: 'advanced'};

  return Vue.extend({
    template:'#layout-editor',
    props: ['module'],
    data: function(){
      return {
        editModeObj: BASIC,
        modes: [BASIC, ADVANCED],
        isHTMLEditorOpen: true,
        isCSSEditorOpen: true,
      };
    },
    computed: {
      htmlSize: function(){
        if(!this.isHTMLEditorOpen){
          return 'closed';
        } else if(this.isHTMLEditorOpen && this.isCSSEditorOpen){
          return 'half';
        } else if(this.isHTMLEditorOpen && !this.isCSSEditorOpen){
          return 'full';
        }
      },
      cssSize: function(){
        if(!this.isCSSEditorOpen){
          return 'closed';
        } else if(this.isCSSEditorOpen && this.isHTMLEditorOpen){
          return 'half';
        } else if(this.isCSSEditorOpen && !this.isHTMLEditorOpen){
          return 'full';
        }
      },
      editMode: function(){
        return this.editModeObj.key;
      }
    },
    methods: {
      expandEditor: function(editorCode){
        if(editorCode === 'html'){
          this.isHTMLEditorOpen = !this.isHTMLEditorOpen;
        } else if(editorCode === 'css'){
          this.isCSSEditorOpen = !this.isCSSEditorOpen;
        }
      },
      emitChange: function(){
        this.$emit('change');
      }
    }
  });
})();
Vue.component('layout-editor',LayoutEditor);

var ContentEditor = (function(){
  return Vue.extend({
    template:'#content-editor',
    props: ['value'],
    data: function(){
      return {
        modes: [{
          label: 'Basic',
          key: 'basic'
        },{
          label: 'Advanced',
          key: 'advanced'
        }],
        selectedMode: {
          label: 'Basic',
          key: 'basic'
        },
        proxyObj: null,
        previewUI: null
      }
    },
    computed: {
      template: function(){
        if(this.value){
          return App.store.getters['content/getTemplateByID'](this.value.templateID);
        }
        return;
      }
    },
    methods: {
      close: function(){
        this.$emit('close');
      },
      save: function(){
        var view = this;
        if(this.value && this.value.data && this.proxyObj){
          this.value.data.result[0].fromJSON(this.proxyObj);
        }
        this.value.previewUI = Object.assign({},this.previewUI);

        App.evt.emit(App.actions.LOADING, true);
        Flybits.api.Content.save(this.value).then(function(){
          view.$emit('close');
        }).catch(function(e){
          App.toast('failed to save content', 'error');
          console.error(e);
        }).then(function(){
          App.evt.emit(App.actions.LOADING, false);
        })
      },

    },
    mounted: function(){
      if(this.value){
        this.proxyObj = this.value.data.result[0].toJSON();
        this.previewUI = Object.assign({},this.value.previewUI);
      }
    }
  });
})();
Vue.component('content-editor',ContentEditor);

var CodeEditor = (function(){
  var BEAUTY = {
    "indent_size": "2",
    "indent_char": " ",
    "max_preserve_newlines": "-1",
    "preserve_newlines": false,
    "keep_array_indentation": false,
    "break_chained_methods": false,
    "indent_scripts": "normal",
    "brace_style": "collapse",
    "space_before_conditional": true,
    "unescape_strings": false,
    "jslint_happy": false,
    "end_with_newline": false,
    "wrap_line_length": "0",
    "indent_inner_html": true,
    "comma_first": false,
    "e4x": false,
    "indent_empty_lines": false,
  };

  /**
   * @param {string} language Language type of the code (eg. js, html, css). 
   */
  return Vue.extend({
    template:'#code-editor',
    props: ['value', 'language'],
    data: function(){
      return {
        editor: null
      }
    },
    methods: {
      beautify: function(str){
        if(this.language === 'js'){
          return js_beautify(str, BEAUTY);
        } else if(this.language === 'html'){
          return html_beautify(str, BEAUTY);
        } else if(this.language === 'css'){
          return css_beautify(str, BEAUTY);
        }
        return str;
      },
      sanitize: function(str){
        return str.split('\n').join('');
      }
    },
    mounted: function(){
      var view = this;
      this.editor = new CodeFlask(this.$refs.code,{
        language: this.language,
        lineNumbers: true,
      });
      if(this.value){
        this.editor.updateCode(this.beautify(this.value));
      }

      this.editor.onUpdate(function(code){
        view.$emit('input', view.sanitize(code));
      });
    }
  });
})();
Vue.component('code-editor',CodeEditor);

var ConfirmButton = (function(){
  return Vue.extend({
    template:'#confirm-button',
    props: ['label'],
    data: function(){
      return {
        isConfirm: false,
      }
    },
    methods: {
      confirm: function(){
        this.isConfirm = true;
      },
      cancel: function(){
        this.isConfirm = false;
      },
      action: function(){
        this.$emit('action');
        this.isConfirm = false;
      }
    }
  });
})();
Vue.component('confirm-button',ConfirmButton);

var DataEditor = (function(){
  return Vue.extend({
    template:'#data-editor',
    props: ['contentTemplate', 'value'],
    data: function(){
      return {
        proxyObj: {}
      };
    },
    watch: {
      value: function(newVal, oldVal){
        this.seedData();
      }
    },
    methods: {
      seedData: function(){
        if(this.value){
          this.proxyObj = this.value;
        }
      },
      updateField: function(evt){
        console.log('> updateEvt', evt);
        App.util.Obj.setByStr(this.proxyObj, evt.key, evt.val);
        this.$emit('input', this.proxyObj);
      },
      getSeedValueByStr: function(keyStr){
        return App.util.Obj.getByStr(this.proxyObj, keyStr);
      },
      getLocalizedKey: function(field){
        var key = field.key;
        if(field.type === 'localized'){
          key = 'localizations.en.' + key;
        }

        return key;
      }
    },
    mounted: function(){
      this.seedData();
    }
  });
})();
Vue.component('data-editor',DataEditor);

var SchemaField = (function(){
  var OBJECT = 'object';
  var ARRAY = 'array';
  var LOCALIZED = 'localized';

  return Vue.extend({
    template:'#schema-field',
    props: ['field', 'index', 'seedValue'],
    data: function(){
      return {
        proxyValue: null,
      }
    },
    computed: {
      indexedKey: function(){
        var key = this.localizedKey(this.field);

        if(this.index > -1){
          key = this.index + '.' + key;
        }
        return key;
      },
      isParent: function(){
        return this.field && (this.field.type === OBJECT || this.field.type === ARRAY);
      },
      isArray: function(){
        return this.field && this.field.type === ARRAY;
      },
      isObjectArray: function(){
        return this.field && this.field.type === ARRAY && this.field.subType === OBJECT;
      },
      isPrimitiveArray: function(){
        return this.field && this.field.type === ARRAY && this.field.subType !== OBJECT;
      }
    },
    watch: {
      proxyValue: function(newVal, oldVal){
        if(!this.isParent){
          this.$emit('change', {
            key: this.indexedKey,
            val: newVal
          });
        }
      },
      seedValue: function(newVal, oldVal){
        this.setDefault();
      }
    },
    methods: {
      collapseAll: function(){
        if(this.isObjectArray){
          this.proxyValue.forEach(function(o){
            o._isCollapsed = true;
          })
        }
      },
      expandAll: function(){
        if(this.isObjectArray){
          this.proxyValue.forEach(function(o){
            o._isCollapsed = false;
          })
        }
      },
      getSeedValueByStr: function(seedObj, keyStr){
        return seedObj?App.util.Obj.getByStr(seedObj, keyStr):null;
      },
      localizedKey: function(field){
        var key = field.key;
        if(field.type === LOCALIZED){
          key = 'localizations.en.' + key;
        }

        return key;
      },
      childChanged: function(changeObject){
        this.$emit('change', {
          key: this.indexedKey + '.' + changeObject.key,
          val: changeObject.val
        });
      },
      addItem: function(){
        if(this.isPrimitiveArray){
          this.proxyValue.push({
            id: App.util.Obj.guid(1),
            value: ""
          });
        } else{
          this.proxyValue.push({
            id: App.util.Obj.guid(1),
            _isCollapsed: false,
            value: {}
          });
        }
        this.$emit('change', {
          key: this.indexedKey,
          val: this.proxyValue.map(function(obj){
            return obj.value;
          })
        });
      },
      removeItem: function(item){
        App.util.Obj.removeObject(this.proxyValue, item);
        this.$emit('change', {
          key: this.indexedKey,
          val: this.proxyValue.map(function(obj){
            return obj.value;
          })
        });
      },
      toggleExpand: function(item){
        item._isCollapsed = !item._isCollapsed;
      },
      setDefault: function(){
        if(this.isObjectArray && this.seedValue){
          this.proxyValue = this.seedValue.map(function(v){
            return {
              id: App.util.Obj.guid(1),
              _isCollapsed: false,
              value: v
            };
          });
        } else if(this.isPrimitiveArray && this.seedValue){
          this.proxyValue = this.seedValue.map(function(v){
            return {
              id: App.util.Obj.guid(1),
              value: v
            };
          });
        } else{
          this.proxyValue = this.seedValue;
        }
      }
    },
    mounted: function(){
      if(this.field && this.seedValue){
        this.setDefault();
      } else if(this.field && this.isArray){
        this.proxyValue = [];
      }
    }
  });
})();
Vue.component('schema-field',SchemaField);

var UiEditor = (function(){
  var BASIC = {label:'Basic', key: 'basic'};
  var ADVANCED = {label: 'Advanced', key: 'advanced'};

  return Vue.extend({
    template:'#ui-editor',
    props: {
      mode: {
        default: BASIC
      },
      value: {
        type: Object
      },
      dataObj: {
        type: Object
      }
    },
    data: function(){
      return {
        modes: [BASIC, ADVANCED],
        isHTMLEditorOpen: true,
        isCSSEditorOpen: true,
      };
    },
    computed: {
      htmlSize: function(){
        if(!this.isHTMLEditorOpen){
          return 'closed';
        } else if(this.isHTMLEditorOpen && this.isCSSEditorOpen){
          return 'half';
        } else if(this.isHTMLEditorOpen && !this.isCSSEditorOpen){
          return 'full';
        }
      },
      cssSize: function(){
        if(!this.isCSSEditorOpen){
          return 'closed';
        } else if(this.isCSSEditorOpen && this.isHTMLEditorOpen){
          return 'half';
        } else if(this.isCSSEditorOpen && !this.isHTMLEditorOpen){
          return 'full';
        }
      },
      editMode: function(){
        return this.mode.key;
      }
    },
    methods: {
      expandEditor: function(editorCode){
        if(editorCode === 'html'){
          this.isHTMLEditorOpen = !this.isHTMLEditorOpen;
        } else if(editorCode === 'css'){
          this.isCSSEditorOpen = !this.isCSSEditorOpen;
        }
      }
    }
  });
})();
Vue.component('ui-editor',UiEditor);

var ViewablePreview = (function(){
  return Vue.extend({
    template:'',
    props: ['dataObj','layout','layoutStr','styleStr','styleURL'],
    data: function(){
      return {}
    },
    computed: {
      data: function(){
        var contentData = this.dataObj?JSON.parse(JSON.stringify(this.dataObj)):null;
        if(contentData){
          App.util.Content.flattenLocales(contentData);
        }

        return contentData;
      }
    },
    methods: {
      layoutString: function () {
        if (this.layout == null || this.layoutStr != null) {
          return this.layoutStr;
        }
        console.log('>layout', this.layout);
        switch (this.layout) {
          case "horizontal": return `<flybits-carousel v-bind:content=\"content\"></flybits-carousel>`
          case "card-buttonlink": return `<card-buttonlink v-bind:data=\"data\"></card-buttonlink>`
          case "vertical": return `<flybits-vertical v-bind:content=\"content\" ></flybits-vertical>`
          case "expose": return `<flybits-expose v-bind:content=\"content\" v-bind:viewall=\"viewall\" v-bind:title=\"name\"></flybits-expose>`
          case "banner-buttonlink": return `<banner-buttonlink v-bind:data=\"data\"></banner-buttonlink>`
          case "banner-timedoffer": return `<banner-timedoffer v-bind:data=\"data\"></banner-timedoffer>`
          case "banner-chart": return `<banner-chart v-bind:data=\"data\"></banner-chart>`
        }
  
        console.error('No template or layout have been defined for your configuration')
      }
    },
    created: function(){
      if(this.data){
        var templateStr = `
          <div class="flb-viewable">
            ${this.layoutString()}
          </div>
        `;
        this.$options.template = templateStr;
      }
      
      if(App.util.Browser.ResourceLoader && this.styleStr){
        var id = this.dataid || ObjUtil.guid(1);
        App.util.Browser.ResourceLoader.loadStyleStr(id, this.styleStr);
      }
      if (App.util.Browser.ResourceLoader && this.styleURL) {
        App.util.Browser.ResourceLoader.loadStyleURL(this.styleURL);
      }
    }
  });
})();
Vue.component('viewable-preview',ViewablePreview);

var CardButtonlink = Vue.extend({
  template: `
    <div class="card-buttonlink card-base">
      <media class="img-blk" v-if="data.media" v-bind:data="data.media"/>
      <div class="main-body" v-if="data">
        <div class="caption2" v-if="data.header">
          {{data.header}}
        </div>
        <div class="title" v-if="data.title">
          {{data.title}}
        </div>
        <div class="caption1" v-if="data.description">
          {{data.description}}
        </div>
        <div class="button-wrap" v-if="data.buttons">
          <div class="button footnote" v-for="(button,index) in data.buttons" v-on:click="actionTrigger(button,index)">
            {{button.text}}
          </div>
        </div>
        <div class="link footnote" v-if="data.link"  v-on:click="actionTrigger(data.link,0)">
            {{data.link.text}}
        </div>
      </div>
      <chart v-if="data.chart" v-bind:data="data.chart"/>
    </div>
  `,
  props: ['data'],
  data: function(){
    return {};
  },
  methods: {
    actionTrigger: function(button, index){
      console.log('> clickity', button, index);
      concierge.openLink(button.actionValue);
    }
  },
  beforeMount: function(){
    var styleKey = 'card-buttonlink';
    var existingStyle = document.head.querySelector('style[key='+styleKey+']');
    if(existingStyle){
      return;
    }
    
    var newStyle = document.createElement('style');
    newStyle.setAttribute('key', styleKey);
    newStyle.innerHTML = `
      .card-buttonlink, .img-blk {
        overflow: hidden;
        object-fit: cover;
      }

      .card-buttonlink .img-blk {
         height: auto;
         max-width: 100%;
      }
      
      .card-buttonlink .main-body {
        margin-top: 6px;
        margin-left: 16px;
        margin-right: 16px;
      }

      .card-buttonlink .main-body * {
         margin-bottom: 16px;
      }
      
      .card-buttonlink .button-wrap .button:first-child {
        border-radius: 18px;
        color: white;
        background-color: #007AFF;
        line-height: max(2.0em, 30px);
        text-align: center;
      }

      .card-buttonlink .button-wrap .button:not(:first-child) {
        border-radius: 18px;
        line-height: max(2.0em, 30px);
        text-align: center;
        border: 1px solid #007AFF;
      }

      .card-buttonlink .link {
        color: #007AFF;
        line-height: max(2.0em, 30px);
      }

    `;
    document.head.prepend(newStyle);
  },
  mounted: function(){}
});
Vue.component('card-buttonlink',CardButtonlink);


var MediaComponent = (function () {
  function loadVidYard() {
    const styleKey = 'vidyard-extended-style'
    var existingVidyard = document.head.querySelector('script[data-type="vidyard"]')
    var existingVidyardStyle = document.head.querySelector('style[key=' + styleKey + ']')
  
    if (existingVidyard) {
      console.log('existing')
      return
    }
  
    var vidyardScript = document.createElement('script')
    vidyardScript.setAttribute('data-type', "vidyard")
    vidyardScript.src = "https://play.vidyard.com/embed/v4.js"
    vidyardScript.async = true
  
    vidyardScript.onerror = function (e) {
      var data = {
        "event": "error"
      };
  
      console.error('failed!!!! ', e)
    }
  
    window.onVidyardAPI = (vidyardEmbed) => {
      vidyardEmbed.api.addReadyListener((_, player) => {
        console.log('ready')
  
      })
    }
  
    var newStyle = document.createElement('style');
    newStyle.setAttribute('key', styleKey);
    newStyle.innerHTML = `
        .vidyard-player-embed iframe,
        .vidyard-player-embed object,
        .vidyard-player-embed embed {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%% !important;
            height: 100%% !important;
    }
    `
    document.head.prepend(newStyle)
    document.body.prepend(vidyardScript)
  
    return `<img class="vidyard-player-embed"  data-uuid="WgLAV4YRy2u6XeRyQoC1Fb" data-type="inline" data-quality="360"/>`
  };


  return Vue.extend({
    props: ['data'],
    mounted: function () {
      if (this.$options.template.length == 0) {
        this.failedToLoad()
      }
    },
    created: function () {
      switch (this.data.mediaType) {
        case "video":
          this.$options.template = loadVidYard()
          break
        case "image":
          this.$options.template = `
                    <img :src="this.data.resourceURL"/>
                `
          break
        default: this.$options.template = ``
      }
    },
    inject: ["failedToLoad"]
  });
})()
Vue.component('media', MediaComponent);
var BaseRoute = (function(){
  function BaseRoute(opts){
    opts = opts || {};
    if(opts.beforeRouteEnter){
      this.extBeforeRouteEnter = opts.beforeRouteEnter;
      delete opts.beforeRouteEnter;
    }
    Flybits.util.Obj.extend(this, opts,{
      mutate: true
    });
  };
  
  BaseRoute.prototype = {
    beforeRouteEnter: function(to, from, next){
      var route = to.matched[0]?to.matched[0].components.default:null;
      setTimeout(function(){
        App.ready.then(function(){
          if(route && route.extBeforeRouteEnter){
            route.extBeforeRouteEnter(to, from, next);
          } else{
            next();
          }
        });
      },1);
    }
  };
  
  return BaseRoute;
})();
var AuthenticatedRoute = (function(){
  function AuthenticatedRoute(opts){
    BaseRoute.call(this, opts);
  }

  AuthenticatedRoute.prototype = Object.create( BaseRoute.prototype );
  AuthenticatedRoute.prototype.constructor = AuthenticatedRoute;

  AuthenticatedRoute.prototype.beforeRouteEnter = function(to, from, next){
    var route = to.matched[0]?to.matched[0].components.default:null;
    setTimeout(function(){
      App.ready.then(function(){
        Flybits.Session.resolveSession().then(function(){
          App.store.dispatch('user/resolveUser', true);
          if(route && route.extBeforeRouteEnter){
            route.extBeforeRouteEnter(to, from, next);
          } else{
            next();
          }
        }).catch(function(e){
          Flybits.Session.clearSession();
          App.authClient.request();          
        });
      });
    },1);
  };

  return AuthenticatedRoute;
})();
var ConciergeManager = (function(){

  return new AuthenticatedRoute({
    template:'#concierge-manager',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        Deferred.settlePromises([
          App.store.dispatch('content/hydrate'),
          App.store.dispatch('zone/hydrate')
        ]).then(function(){
          vm.zones = App.store.state.zone.zones;
          vm.selectZone(vm.zones[0]);
        }).catch(function(e){
          console.error(e);
          App.toast('Failed to load data', 'error');
        }).then(function(){
          vm.isLoading = false;
        });
      })
    },
    data: function(){
      return {
        isLoading: true,
        selectedModule: null,
        selectedZone: null,
        zones: [],
        layoutTypeOptions: [{
          label: 'Default',
          key: 'default'
        },{
          label: 'Custom',
          key: 'custom'
        }],
        changeHash: '',
      }
    },
    methods: {
      toggleHash: function(){
        this.changeHash = App.util.Obj.guid();
      },
      selectZone: function(zone){
        this.selectedZone = zone;
        if(zone){
          this.changeHash = App.util.Obj.hash(JSON.stringify(zone.toJSON()));
        }
      },
      editModuleLayout: function(module){
        this.selectedModule = module;
        if(module){
          this.selectZone();
          this.changeHash = App.util.Obj.hash(JSON.stringify(module.toJSON()));
        } else{
          this.selectZone(this.zones[0]);
        }
      },
      addZone: function(){
        this.zones.push(new Zone())
      },
      removeZone: function(zone){
        App.util.Obj.removeObject(this.zones, zone);
      },
      addModule: function(zone){
        zone.modules.push(new Module());
      },
      removeModule: function(zone, module){
        App.util.Obj.removeObject(zone.modules, module);
      },
      findModuleByID: function(id, onlyReturnIndex){
        for(let zIndex = 0; zIndex < this.zones.length; zIndex++){
          for(let mIndex = 0; mIndex < this.zones[zIndex].modules.length; mIndex++){
            if(this.zones[zIndex].modules[mIndex].id === id){
              if(onlyReturnIndex){
                return mIndex;
              }
              return this.zones[zIndex].modules[mIndex];
            }
          }
        }
        if(onlyReturnIndex){
          return -1;
        }
        return null;
      },
      findZoneByID: function(id){
        return this.zones.filter(function(z){
          return z.id === id;
        })[0];
      },
      reorder: function(elemID, targetZoneID, sourceZoneID, siblingID){
        var module = this.findModuleByID(elemID);
        var targetZone = this.findZoneByID(targetZoneID);
        var sourceZone = this.findZoneByID(sourceZoneID);
        
        App.util.Obj.removeObject(sourceZone.modules, module);
        var siblingIndex = this.findModuleByID(siblingID, true);
        if(siblingIndex >= 0){
          targetZone.modules.splice(siblingIndex, 0, module);
        } else{
          targetZone.modules.push(module);
        }

        this.selectZone(this.selectedZone);
      },
      save: function(){
        App.evt.emit(App.actions.LOADING, true);
        App.store.dispatch('zone/saveAll').catch(function(e){
          App.toast('failed to save configuration', 'error');
          console.error(e);  
        }).then(function(){
          App.evt.emit(App.actions.LOADING, false);
        })
      }
    },
    mounted: function(){
      var view = this;
      var nodes = view.$el.querySelectorAll('.module-item');
      nodes = [].slice.call(nodes);
      var drake = dragula(nodes,{
        direction: 'vertical',
        slideFactorY: 5,
        slideFactorX: 5,
        isContainer: function(el){
          return el.classList.contains('module-list');
        },
        invalid: function(el, handle){
          return el.classList.contains('add-btn');
        },
        mirrorContainer: view.$el.querySelector('.module-list')
      });
      drake.on('drop', function(el, target, source, sibling){
        view.reorder(el.getAttribute('data-id'), target.getAttribute('data-zid'), source.getAttribute('data-zid'), sibling?sibling.getAttribute('data-id'):undefined);
      });

      var mouseMoveHandler = function(evt){
        if(evt.clientY > screen.height - 100){
          view.$refs.zonelist.scrollTop = view.$refs.zonelist.scrollTop + 10;
        } else if(evt.clientY < 160){
          view.$refs.zonelist.scrollTop = view.$refs.zonelist.scrollTop - 10;
        }
      };
      drake.on('drag', function(el, source){
        document.addEventListener('mousemove',mouseMoveHandler);
      })
      drake.on('drop', function(el, target, source, sibling){
        document.removeEventListener('mousemove',mouseMoveHandler);
      });
    }
  });

})();
Vue.component('concierge-manager',ConciergeManager);
var ExperienceTemplates = (function(){

  return {
    template:'#experience-templates',
  };

})();
Vue.component('experience-templates',ExperienceTemplates);
var SettingsPage = (function(){

  return {
    template:'#settings-page',
  };

})();
Vue.component('settings-page',SettingsPage);
var SplashPage = (function(){

  return new BaseRoute({
    template: '#splash-page',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        App.store.dispatch('user/resolveUser', true).then(function(){
          App.router.replace({
            name: 'conciergeManager'
          });
        }).catch(function(e){
          console.error(e);
          Flybits.Session.clearSession();
          App.authClient.request();
        });
      })
    }
  });

})();
Vue.component('splash-page',SplashPage);
var AuthCallback = (function(){

  return new BaseRoute({
    template:'#auth-callback',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        App.evt.emit(App.actions.LOADING, true);
        App.authClient.requestSPAuthz().then(function(res){
          if(res && res.accessToken){
            Flybits.Session.setUserToken(res.accessToken);
            App.store.dispatch('user/resolveUser');
            App.router.replace({
              name: 'conciergeManager'
            });
          } else{
            console.error('> uh oh: no valid accessToken')
            App.toast('Authorization denied','error');
            App.store.dispatch('user/logout');
            App.router.replace({
              name: 'login'
            });
          }
        }).catch(function(e){
          console.error('> blah', e);
          App.toast('Authorization denied','error');
          App.store.dispatch('user/logout');
          App.router.replace({
            name: 'login'
          });
        }).then(function(){
          App.evt.emit(App.actions.LOADING, false);
        });
      });
    }
  });

})();
Vue.component('auth-callback',AuthCallback);
var LoginPage = (function(){

  return new BaseRoute({
    template:'#login-page',
    methods: {
      goto: function(){
        App.evt.emit(App.actions.LOADING, true);
        App.router.replace({
          name: 'conciergeManager'
        });
      }
    }
  });

})();
Vue.component('login-page',LoginPage);
var EditContent = (function(){

  return new BaseRoute({
    template:'#edit-content',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        App.evt.on(App.actions.ONMSG, function(obj){
          vm.hydrate(obj);
        });
        if(App.vm.lastSeed){
          vm.hydrate(App.vm.lastSeed);
        }
      });
    },
    data: function(){
      return {
        isLoading: true,
        content: null,
        contentTemplate: null,
      }
    },
    methods: {
      hydrate: function(obj){
        var vm = this;
        var { contentTemplateId, contentInstanceId, token } = obj;
        // var contentTemplate = obj.contentTemplate?new Flybits.ContentTemplate().fromJSON(obj.contentTemplate):null;

        App.store.dispatch('content/getByID', {id: contentInstanceId, token}).then(function(content){
          vm.content = content;
          return App.store.dispatch('content/getTemplateByID', content.templateID);
        }).then(function(template){
          vm.contentTemplate = template;
        }).catch(function(e){
          console.error(e);
          App.toast('Failed to load data', 'error');
        }).then(function(){
          vm.isLoading = false;
        });
      },
      close: function(){
        App.evt.emit(App.actions.SENDMSG,{
          action: 'close'
        });
      }
    }
  });

})();
Vue.component('edit-content',EditContent);
var ContentManager = (function(){

  return new AuthenticatedRoute({
    template:'#content-manager',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        App.store.dispatch('content/hydrate').then(function(){
          vm.content = App.store.state.content.content;
        }).catch(function(e){
          console.error(e);
          App.toast('Failed to load data', 'error');
        }).then(function(){
          vm.isLoading = false;
        });
      })
    },
    data: function(){
      return {
        isLoading: true,
        content: [],
        labelFilter: [],
        selectedContent: null,
        searchKey: '',
        sortKey: 'name',
        sortDirection: 'ascending'
      }
    },
    computed: {
      proxyContent: function(){
        var view = this;
        var searchKey = this.searchKey.toLowerCase();
        return this.content.filter(function(c){
          var toReturn = true;

          if(searchKey){
            var name = c.name?c.name.toLowerCase():'';
            var description = c.description?c.description.toLowerCase():'';
  
            toReturn = toReturn && (name.indexOf(searchKey) > -1 || description.indexOf(searchKey) > -1);
          }

          if(view.labelFilter.length){
            toReturn = toReturn && App.util.Obj.intersection(c.labels, view.labelFilter).length > 0;
          }

          return toReturn;          
        }).sort(function(a, b){
          var aAttr = a[view.sortKey];
          var bAttr = b[view.sortKey];

          if(aAttr < bAttr){
            return view.sortDirection === 'ascending'?-1:1;
          } else{
            return view.sortDirection === 'ascending'?1:-1;
          }
        });
      },
      allLabels: function(){
        var labelMap = {};
        this.content.forEach(function(c){
          c.labels.forEach(function(label){
            labelMap[label] = true;
          });
        });

        var labelFilter = this.labelFilter;
        return Object.keys(labelMap).filter(function(label){
          return labelFilter.indexOf(label) < 0;
        }).sort();
      }
    },
    watch: {
      searchKey: function(newVal, oldVal){
        this.selectedContent = null;
      },
      sortKey: function(newVal, oldVal){
        this.selectedContent = null;
      },
      sortDirection: function(newVal, oldVal){
        this.selectedContent = null;
      },
    },
    methods: {
      select: function(content){
        this.selectedContent = content;
      },
      clearSearch: function(){
        this.searchKey = '';
      },
      closeEdit: function(){
        this.selectedContent = null;
      }
    }
  });

})();
Vue.component('content-manager',ContentManager);
var ConfigStore = (function(){
  var deferredInit = new Deferred();

  return {
    namespaced: true,
    state: {
      initPromise: deferredInit.promise,
      initialized: false,
      HOST: 'https://api.demo.flybits.com',
      res: {},
      debug: false
    },
    mutations: {
      setDefaults: function(state, json){
        state.HOST = json.HOST;
        state.APPHOST = json.APPHOST;
        state.PROJECTID = json.PROJECTID;
        state.PIXELHOST = json.PIXELHOST;
        state.CLIENTID = json.CLIENTID;
        state.res = json.res;
        state.store = json.store;
        state.debug = json.debug;
        state.namespace = json.namespace;
      },
      setInitialized: function(state){
        deferredInit.resolve();
        state.initialized = true;
      }
    },
    actions: {
      parse: function(context){
        var def = new Deferred();

        fetch(App.ext.CONFIG).then(function(resp){
          if(resp.status !== 200){
            throw new Validation().addError("Configuration file not found","Reverting to default configuration. No configuration found at:"+app.ext.CONFIG,{
              code: Flybits.Validation.type.MISSINGARG
            });
          }
          return resp.json();
        }).then(function(json){
          context.commit('setDefaults', json.defaults);
          context.commit('setInitialized');
          def.resolve(json.defaults);
        }).catch(function(ex){
          if(ex instanceof Validation){
            def.reject(ex);
          } else{
            def.reject(new Validation().addError("Failed to read configuration file.","Reverting to default configuration. Configuration format incorrect at:"+app.ext.CONFIG,{
              code: Validation.type.MALFORMED
            }));
          }
        });

        return def.promise;
      }
    }
  };
})();
var UserStore = (function(){
  var deferredInit = new Deferred();
  const DBKeys = {
    USER: 'user'
  };

  return {
    namespaced: true,
    state: {
      initPromise: deferredInit.promise,
      initialized: false,
      isAdmin: false,
      user: null
    },
    mutations: {
      setInitialized: function(state){
        deferredInit.resolve();
        state.initialized = true;
      },
      setUser: function(state, user){
        state.user = user;
        App.cache.setItem(DBKeys.USER, user.toJSON());
      },
      clearUser: function(state){
        state.isAdmin = false;
        App.cache.removeItem(DBKeys.USER);
      }
    },
    actions: {
      logout: function(context){
        context.commit('clearUser');
        Flybits.Session.disconnect();
      },
      resolveUser: function(context, bypassNetwork){
        var def = new Flybits.Deferred();
        var cachePromise = App.cache.getItem(DBKeys.USER);
        var sdkPromise = bypassNetwork?Promise.resolve():Flybits.api.User.getSignedInUser();
        
        Flybits.Deferred.settlePromises([cachePromise, sdkPromise]).then(function(results){
          if(results[0].status === 'resolved' && 
             results[1].status === 'resolved'){
            if(bypassNetwork && results[0].result){
              let user = new Flybits.User(results[0].result);
              context.commit('setUser', user);
              def.resolve(user);
            } else if(!bypassNetwork && results[1].result){
              let user = results[1].result;
              context.commit('setUser', user);
              def.resolve(user);
            } else{
              def.reject(new Flybits.Validation().addError('No valid session', '', {
                type: Flybits.Validation.type.NOTFOUND
              }));
            }
          } else{
            def.reject(new Flybits.Validation().addError('No valid session', '', {
              type: Flybits.Validation.type.NOTFOUND
            }));
          }
        }).catch(function(e){
          def.reject(new Flybits.Validation().addError('No valid session', '', {
            type: Flybits.Validation.type.NOTFOUND
          }));
        });

        return def.promise;
      }
    }
  };
})();
var ZoneStore = (function(){
  var deferredInit = new Deferred();

  var API = {
    getObject: function(){
      return Flybits.api.ProjectSettings.get(App.store.state.config.namespace.ZONES);
    },
    saveObject: function(obj){
      return Flybits.api.ProjectSettings.create(App.store.state.config.namespace.ZONES, obj);
    }
  };
  
  return {
    namespaced: true,
    state: {
      initPromise: deferredInit.promise,
      initialized: false,
      zones: []
    },
    getters: {
      
    },
    mutations: {
      setInitialized: function(state){
        deferredInit.resolve();
        state.initialized = true;
      },
      setZones: function(state, zonesArr){
        state.zones = zonesArr.map(function(obj){
          return new Zone(obj);
        }) || [];
      }
    },
    actions: {
      hydrate: function(context){
        var def = new Deferred();
        
        API.getObject().then(function(obj){
          context.commit('setZones', obj.zones);
          if(!context.state.initialized){
            context.commit('setInitialized');
          }
          def.resolve();
        }).catch(function(e){
          def.reject(e);
        });

        return def.promise;
      },
      saveAll: function(context){
        return API.saveObject({
          zones: context.state.zones
        });
      }
    }
  }
})();
var ContentStore = (function(){
  var deferredInit = new Deferred();

  var API = {
    getContent: function(id, token){
      var def = new Deferred();
      var url = Flybits.cfg.HOST + Flybits.cfg.res.CONTENTS + 
                '/' + id;
      var query = {
        data: true,
        limit: 200,
        managementMode: true,
        returnRichText: true,
        disableContextEmbed: true
      };

      query = Flybits.util.Api.toURLParams(query);
      if(query !== ''){
        url += '?' + query;
      }

      Flybits.util.Api.flbFetch(url, {
        method: 'GET',
        headers: { 'x-authorization': token ? token : null },
      }).then(function(res){
        def.resolve(new Content(res.body));
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    getContents: function(opts){
      opts = opts || {};
      var def = new Deferred();
      var url = Flybits.cfg.HOST + Flybits.cfg.res.CONTENTS;
      var query = {
        data: true,
        limit: 200,
        managementMode: true,
        returnRichText: true,
        disableContextEmbed: true
      };
      if(opts.labels && opts.labels.length){
        query.labelsFormula = '('+opts.labels.join(';')+')'
      }

      query = Flybits.util.Api.toURLParams(query);
      if(query !== ''){
        url += '?' + query;
      }

      Flybits.util.Api.flbFetch(url, {
        method: 'GET'
      }).then(function(res){
        def.resolve(res.body.data);
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    saveInstance: function(obj){
      var def = new Deferred();
      var url = Flybits.cfg.HOST + Flybits.cfg.res.CONTENTS
                + '/' + obj.id;

      Flybits.util.Api.flbFetch(url, {
        method: 'PUT',
        body: JSON.stringify(obj)
      }).then(function(res){
        def.resolve();
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    saveData: function(obj, instanceID, dataID){
      var def = new Deferred();
      var url = Flybits.cfg.HOST + Flybits.cfg.res.CONTENTS
                + '/' + instanceID + '/data/' + dataID;

      Flybits.util.Api.flbFetch(url, {
        method: 'PUT',
        body: JSON.stringify(obj)
      }).then(function(res){
        def.resolve();
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    getAllTemplates: function(){
      return Flybits.api.ContentTemplate.getAll({
        paging: {
          limit: 200
        }
      });
    }
  }

  return {
    namespaced: true,
    state: {
      initPromise: deferredInit.promise,
      initialized: false,
      content: [],
      templates: []
    },
    getters: {
      getTemplateByID: function(state){
        return function(id){
          return state.templates.filter(function(t){
            return t.id === id;
          })[0];
        };
      },
      getContentByLabels: function(state){
        return function(labels){
          return state.content.filter(function(c){
            return App.util.Obj.intersection(c.labels, labels).length > 0;
          });
        }
      }
    },
    mutations: {
      setInitialized: function(state){
        deferredInit.resolve();
        state.initialized = true;
      },
      addContent: function(state, content){
        var exists = state.content.filter(function(c){
          return c.id === content.id;
        })[0];
        if(!exists){
          state.content.push(content);
        }
      },
      setContent: function(state, contentArr){
        state.content = contentArr.map(function(c){
          return new Content(c);
        });
      },
      addTemplate: function(state, template){
        var exists = state.templates.filter(function(t){
          return t.id === template.id;
        })[0];
        if(!exists){
          state.templates.push(template);
        }
      },
      setTemplates: function(state, templateArr){
        state.templates = templateArr;
      }
    },
    actions: {
      getByID: function(context, params){
        const { id, token } = params;
        var fetchPromise = API.getContent(id, token);
        fetchPromise.then(function(content){
          context.commit('addContent', content);
        });

        return fetchPromise;
      },
      getTemplateByID: function(context, id){
        var fetchPromise = Flybits.api.ContentTemplate.get(id);
        fetchPromise.then(function(template){
          context.commit('addTemplate', template);
        });

        return fetchPromise;
      },
      hydrate: function(context){
        var def = new Deferred();
        var promises = [
          API.getAllTemplates(),  
          API.getContents()
        ];

        Deferred.settlePromises(promises).then(function(response){
          if(response[0].status === 'rejected'){
            App.toast('Failed to load Content Templates');
            console.error(response[0].result);
          } else{
            context.commit('setTemplates', response[0].result.result);
          }
          if(response[1].status === 'rejected'){
            App.toast('Failed to load Content');
            console.error(response[1].result);
            def.reject();
          } else{
            context.commit('setContent', response[1].result);
            def.resolve();
          }

          if(!context.state.initialized){
            context.commit('setInitialized');
          }
        });

        return def.promise;
      }
    }
  };
})();
var App = (function(){
  var deferredReady = new Deferred();

  var App = {
    ready: deferredReady.promise,
    vm: null,
    evt: null,
    ext:{
      CONFIG:"res/config.json",
      VERSION: 'version.txt'
    },
    actions:{
      LOADING: "loading",
      CONFIG_UPDATE: "configupdated",
      VIBRATE: 'vibrate',
      OPENMANAGEIMAGE: 'open_manage_image',
      CHOOSELOCATION: 'choose_location',
      SENDMSG: 'send_message',
      ONMSG: 'on_message'
    },
    util: {},
    checkVersion: function(){
      fetch(this.ext.VERSION).then(function(resp){
        return resp.text();
      }).then(function(fileStr){
        App.vm.version = fileStr;
        console.debug(fileStr);
      });
    },
    toast: function(msg, msgType, duration){
      msgType = msgType || 'normal';

      if(typeof msg === 'object'){
        try{
          msg = JSON.stringify(msg);
        } catch(e){
          console.log('> toast stringify fail', e);
        }
      }

      var opt = {
        text: msg,
        gravity: 'bottom',
        duration: 3000
      };
      if(msgType === 'error'){
        opt.backgroundColor = '#b20000';
        opt.duration = 7000;
      }
      if(duration){
        opt.duration = duration;
      }

      Toastify(opt).showToast();
    },
    startup: function(){
      App.authClient = new IAMFlybits.oauth2PKCE.Client({
        spHost: App.store.state.config.HOST,
        projectID: App.store.state.config.PROJECTID,
        clientID: App.store.state.config.CLIENTID,
        appCallbackURL: App.store.state.config.APPHOST + '/' + 
                        App.store.state.config.res.AUTHCALLBACK
      });

      App.cache = new window.localforage.createInstance({
        name: App.store.state.config.store.USERDB
      });

      Flybits.init({
        HOST: App.store.state.config.HOST
      }).then(function(){
        deferredReady.resolve();
      });
    },
  };

  var router = App.router = new VueRouter({
    routes: [{
      path: '/',
      name: 'splash',
      component: SplashPage
    },{
      path: '/login',
      name: 'login',
      component: LoginPage
    },{
      path: '/settings',
      name: 'settings',
      component: SettingsPage
    },{
      path: '/auth-callback',
      name: 'authCallback',
      component: AuthCallback
    },{
      path: '/concierge/manage',
      name: 'conciergeManager',
      component: ConciergeManager
    },{
      path: '/content/manage',
      name: 'contentManager',
      component: ContentManager
    },{
      path: '/content/edit/:id?',
      name: 'editContent',
      component: EditContent
    },{
      path: '/content/create',
      name: 'createContent',
      component: EditContent
    },]
  });

  var store = App.store = new Vuex.Store({
    modules: {
      config: ConfigStore,
      zone: ZoneStore,
      user: UserStore,
      content: ContentStore
    }
  });

  Vue.config.productionTip = false;
  App.vm = new Vue({
    router: router,
    store: store,
    el: '.container',
    data: function(){
      return {
        isLoaded: false,
        isLoading: false,
        isCFGLoaded: false,
        isDebug: false,
        errorText: '',
        lastSeed: null
      };
    },
    computed: {
    },
    watch: {
    },
    methods: {
      refreshApp: function(){
        window.location.reload();
      }
    },
    mounted: function(){
      this.isLoaded = true;
      window.App = App;
    },
  });
  
  /**
   * Resusing the Vue event emitter interface but keeping it generic so we can
   * swap it out for our favourite event emitter if we ever need to.
   */
  App.vm.on = App.vm.$on;
  App.vm.off = App.vm.$off;
  App.vm.emit = App.vm.$emit;
  App.evt = App.vm;

  var loaderStack = [];
  var loadStart = 0;
  App.evt.on(App.actions.LOADING,function(bool, noDelay){
    if(bool){
      App.vm.isLoading = true;
      if(loaderStack.length <= 0){
        loadStart = new Date().getTime();
      }
      loaderStack.push(true);
    } else if(!bool && loaderStack.length > 1){
      loaderStack.pop();
    } else if(!bool){
      loaderStack.pop();
      var now = new Date().getTime();
      if(now - loadStart < 300 && !noDelay){
        setTimeout(function(){
          App.vm.isLoading = false;
        },300);
      } else{
        App.vm.isLoading = false;
      }
    }
  });

  App.evt.on(App.actions.VIBRATE, function(opt){
    if('vibrate' in navigator){
      var input = opt? opt.pattern || opt.duration || [200,50,200] : [200,50,200];
      navigator.vibrate(input);
    }
  });

  App.evt.on(App.actions.SENDMSG, function(payload){
    window.parent.postMessage(payload, '*');
  });
  window.addEventListener('message', function(evt){
    if(evt.data){
      console.log('> message received', evt.data);
      App.evt.emit(App.actions.ONMSG, evt.data);
      App.vm.lastSeed = evt.data;
    } else{
      console.log('> empty message received', evt);
    }
  });

  return App;
})();

/*************************************************/

App.checkVersion();
App.store.dispatch('config/parse').then(function(){
  App.startup();
}).catch(function(e){
  console.log('> initialiaation failed', e);
});
App.util.Obj = (function(){
  var s4 = function(){
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  };
  
  var Obj = {
    guid:function(tuples){
      var str = '';
      if(tuples && tuples > 0){
        for(var i = 0; i < tuples; i++){
          str += str !== ''?'-'+s4():s4();
        }
        return str;
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
    },
    getByStr: function(obj, keyStr){
      // convert indexes to properties
      keyStr = keyStr.replace(/\[(\w+)\]/g, '.$1');
      // strip a leading dot
      keyStr = keyStr.replace(/^\./, '');
      var aKeys = keyStr.split('.');
      for (var i = 0, n = aKeys.length; i < n; ++i) {
        var key = aKeys[i];
        if (key in obj) {
          obj = obj[key];
        } else {
          return;
        }
      }
      return obj;
    },
    setByStr: function(obj, keyStr, val){
      // convert indexes to properties
      keyStr = keyStr.replace(/\[(\w+)\]/g, '.$1');
      // strip a leading dot
      keyStr = keyStr.replace(/^\./, '');
      var aKeys = keyStr.split('.');
      for (var i = 0, n = aKeys.length; i < n; i++) {
        var key = aKeys[i];
        if (key in obj && (i+1) < n) {
          obj = obj[key];
        } else if(!(key in obj) && (i+1) < n){
          obj[key] = {};
          obj = obj[key];
        } else {
          obj[key] = val;
          return val;
        }
      }
    },
    zero2Pad: function(num){
      return ('0'+num).slice(-2);
    },
    removeObject:function(arr,obj,findCallback){
      var index = arr.indexOf(obj);

      if(findCallback){
        var objs = arr.filter(findCallback);
        if(objs.length > 0){
          index = arr.indexOf(objs[0]);
        }
      }

      if(index >= 0){
        return arr.splice(index,1);
      }
      return arr;
    },
    debounce: function(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this, args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    difference: function(currentSource, sourceOfTruth){
      var diff = [];

      for(var i = 0; i < currentSource.length; i++){
        if(sourceOfTruth.indexOf(currentSource[i]) < 0){
          diff.push(currentSource[i]);
        }
      }
      return diff;
    },
    intersection: function(currentSource, sourceOfTruth){
      var union = [];

      for(var i = 0; i < currentSource.length; i++){
        if(sourceOfTruth.indexOf(currentSource[i]) > -1){
          union.push(currentSource[i]);
        }
      }
      return union;
    },
    hash: function(str) {
      var hash = 0, i, chr;
      if (str.length === 0) return hash;
      for (i = 0; i < str.length; i++) {
        chr   = str.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
      }
      return 'f'+hash;
    },
    replaceAllStr: function(str, search, replacement){
      return str.split(search).join(replacement);
    },
    stringToColour: function(str) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      var colour = '#';
      for (var i = 0; i < 3; i++) {
        var value = (hash >> (i * 8)) & 0xFF;
        colour += ('00' + value.toString(16)).substr(-2);
      }
      return colour;
    },
    getContrastYIQ: function(hexcolor){
      var r = parseInt(hexcolor.substr(0,2),16);
      var g = parseInt(hexcolor.substr(2,2),16);
      var b = parseInt(hexcolor.substr(4,2),16);
      var yiq = ((r*299)+(g*587)+(b*114))/1000;
      return (yiq >= 128) ? 'black' : 'white';
    },
    hexToRGB: function(hexStr){
      if(hexStr[0] == "#"){
        hexStr = hexStr.slice(1);
      }
      var num = parseInt(hexStr,16);
      var r = (num >> 16);
      var g = (num & 0x0000FF);
      var b = ((num >> 8) & 0x00FF);

      return {
        r: r,
        g: g,
        b: b
      };
    },
    lightenDarkenColor: function(col, amt) {
      var usePound = false;
      if(col[0] == "#"){
        col = col.slice(1);
        usePound = true;
      }
      
      var num = parseInt(col,16);
  
      var r = (num >> 16) + amt;
      if(r > 255){
        r = 255;
      } else if(r < 0){
        r = 0;
      }
  
      var b = ((num >> 8) & 0x00FF) + amt;
      if(b > 255){
        b = 255;
      } else if(b < 0){
        b = 0;
      }
  
      var g = (num & 0x0000FF) + amt;
      if(g > 255){
        g = 255;
      } else if(g < 0){
        g = 0;
      }
  
      return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
    },
    darken: function(hexStr, percent){
      return this.lightenDarkenColor(hexStr, -percent);
    },
    lighten: function(hexStr, percent){
      return this.lightenDarkenColor(hexStr, percent);
    },
    randomInt:function(min,max){
      return Math.floor(Math.random()*(max-min+1)+min);
    }
  };

  Obj.extend = (function(){
    function isMergeableObject(val) {
      var nonNullObject = val && typeof val === 'object';

      return nonNullObject && Object.prototype.toString.call(val) !== '[object RegExp]' && Object.prototype.toString.call(val) !== '[object Date]';
    }

    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }

    function cloneIfNecessary(value, optionsArgument) {
      var clone = optionsArgument && optionsArgument.clone === true;
      return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value;
    }

    function defaultArrayMerge(target, source, optionsArgument) {
      var destination = target.slice();
      source.forEach(function (e, i) {
        if (typeof destination[i] === 'undefined') {
          destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
          destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
          destination.push(cloneIfNecessary(e, optionsArgument));
        }
      });
      return destination;
    }

    function mergeObject(target, source, optionsArgument) {
      var destination = {};
      if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
          destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
      }
      Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
          destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
          destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
      });
      return destination;
    }

    function deepmerge(target, source, optionsArgument) {
      var array = Array.isArray(source);
      var options = optionsArgument || { arrayMerge: defaultArrayMerge };
      var arrayMerge = options.arrayMerge || defaultArrayMerge;

      if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument);
      } else {
        return mergeObject(target, source, optionsArgument);
      }
    }

    deepmerge.all = function deepmergeAll(array, optionsArgument) {
      if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements');
      }

      // we are sure there are at least 2 values, so it is safe to have no initial value
      return array.reduce(function (prev, next) {
        return deepmerge(prev, next, optionsArgument);
      });
    };

    return deepmerge;
  })();

  return Obj;
})();
App.util.Api = (function(){
  var defaultAjaxOpts = {
    method: 'GET',
    headers: {}
  };

  var Api = {
    fetch: function(url,opts){
      opts = opts || {};
      opts.respType = opts.respType || 'json';
      var def = new Deferred();
      
      var ajaxOpts = ObjUtil.extend({},defaultAjaxOpts);
      var isJSON = opts.respType === 'json';
      delete opts.respType;
      ObjUtil.extend(ajaxOpts,opts);

      fetch(url,ajaxOpts).then(this.checkResult).then(this.getResultBody)
        .then(function(respObj){
          if(isJSON){
            try{
              respObj.body = Api.parseResponse(respObj.body);
              def.resolve(respObj);
            } catch(e){
              def.reject(new Validation().addError("Request Failed","Unexpected server response.",{
                code: Validation.type.MALFORMED,
              }));
            }
          } else{
            def.resolve(respObj);
          }
        }).catch(function(resp){
          Api.getResultBody(resp).then(function(resultObj){
            var parsedResp = Api.parseErrorMsg(resultObj.body);
            def.reject(new Validation().addError('Request error',parsedResp,{
              serverCode: resp.status
            }));
          });
        });

      return def.promise;
    },
    checkResult: function(resp){
      if(resp.status >= 200 && resp.status < 300){
        return resp;
      }
      throw resp;
    },
    getResultBody: function(resp){
      var def = new Deferred();
      if(resp && resp.text){
        var respHeaders = {};
        resp.headers.forEach(function(val,key){
          respHeaders[key] = val;
        });
        resp.text().then(function(str){
          def.resolve({
            body: str,
            headers: respHeaders
          });
        }).catch(function(e){
          def.reject(e);
        });
      } else{
        def.resolve({
          body: "",
          headers: {}
        });
      }

      return def.promise;
    },
    getResultJSON: function(resp){
      return resp.json();
    },
    htmlEncode:function(value){
      /*global encodeURIComponent*/
      return encodeURIComponent(value);
    },
    htmlDecode:function(str){
      return str.replace(/&#?(\w+);/g, function(match, dec) {
        if(isNaN(dec)) {
          chars = {quot: 34, amp: 38, lt: 60, gt: 62, nbsp: 160, copy: 169, reg: 174, deg: 176, frasl: 47, trade: 8482, euro: 8364, Agrave: 192, Aacute: 193, Acirc: 194, Atilde: 195, Auml: 196, Aring: 197, AElig: 198, Ccedil: 199, Egrave: 200, Eacute: 201, Ecirc: 202, Euml: 203, Igrave: 204, Iacute: 205, Icirc: 206, Iuml: 207, ETH: 208, Ntilde: 209, Ograve: 210, Oacute: 211, Ocirc: 212, Otilde: 213, Ouml: 214, times: 215, Oslash: 216, Ugrave: 217, Uacute: 218, Ucirc: 219, Uuml: 220, Yacute: 221, THORN: 222, szlig: 223, agrave: 224, aacute: 225, acirc: 226, atilde: 227, auml: 228, aring: 229, aelig: 230, ccedil: 231, egrave: 232, eacute: 233, ecirc: 234, euml: 235, igrave: 236, iacute: 237, icirc: 238, iuml: 239, eth: 240, ntilde: 241, ograve: 242, oacute: 243, ocirc: 244, otilde: 245, ouml: 246, divide: 247, oslash: 248, ugrave: 249, uacute: 250, ucirc: 251, uuml: 252, yacute: 253, thorn: 254, yuml: 255, lsquo: 8216, rsquo: 8217, sbquo: 8218, ldquo: 8220, rdquo: 8221, bdquo: 8222, dagger: 8224, Dagger: 8225, permil: 8240, lsaquo: 8249, rsaquo: 8250, spades: 9824, clubs: 9827, hearts: 9829, diams: 9830, oline: 8254, larr: 8592, uarr: 8593, rarr: 8594, darr: 8595, hellip: 133, ndash: 150, mdash: 151, iexcl: 161, cent: 162, pound: 163, curren: 164, yen: 165, brvbar: 166, brkbar: 166, sect: 167, uml: 168, die: 168, ordf: 170, laquo: 171, not: 172, shy: 173, macr: 175, hibar: 175, plusmn: 177, sup2: 178, sup3: 179, acute: 180, micro: 181, para: 182, middot: 183, cedil: 184, sup1: 185, ordm: 186, raquo: 187, frac14: 188, frac12: 189, frac34: 190, iquest: 191, Alpha: 913, alpha: 945, Beta: 914, beta: 946, Gamma: 915, gamma: 947, Delta: 916, delta: 948, Epsilon: 917, epsilon: 949, Zeta: 918, zeta: 950, Eta: 919, eta: 951, Theta: 920, theta: 952, Iota: 921, iota: 953, Kappa: 922, kappa: 954, Lambda: 923, lambda: 955, Mu: 924, mu: 956, Nu: 925, nu: 957, Xi: 926, xi: 958, Omicron: 927, omicron: 959, Pi: 928, pi: 960, Rho: 929, rho: 961, Sigma: 931, sigma: 963, Tau: 932, tau: 964, Upsilon: 933, upsilon: 965, Phi: 934, phi: 966, Chi: 935, chi: 967, Psi: 936, psi: 968, Omega: 937, omega: 969}
          if (chars[dec] !== undefined){
            dec = chars[dec];
          }
        }
        return String.fromCharCode(dec);
      });
    },
    base64Decode: function(str){
      return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    },
    parseResponse: function(rawResponse){
      return JSON.parse(rawResponse,function(key,val){
        if(typeof val === "string"){
          return api.htmlDecode(val);
        }
        return val;
      });
    },
    parseErrorMsg: function(rawResponse){
      try{
        var resp = this.parseResponse(rawResponse);
      } catch(e){
        return "Malformed server response";
      }
      var msg = null;

      if(resp){
        if(resp.error){
          resp = resp.error;
        }
        
        return resp.messageJSON || resp.exceptionMessage || resp.message || "Unexpected error has occurred";
      }

      return msg;
    },
    parseYoutubeID: function(url){
      url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      return undefined !== url[2]?url[2].split(/[^0-9a-z_\-]/i)[0]:url[0];
    }
  };

  return Api;
})();
App.util.Browser = (function(){
  Date.prototype.monthNames = [
    "January", "February", "March",
    "April", "May", "June",
    "July", "August", "September",
    "October", "November", "December"
  ];
  Date.prototype.dayNames = [
    "Sunday", "Monday", "Tuesday",
    "Wednesday", "Thursday", "Friday", "Saturday"
  ];
  Date.prototype.getMonthName = function() {
    return this.monthNames[this.getMonth()];
  };
  Date.prototype.getShortMonthName = function () {
    return this.getMonthName().substr(0, 3);
  };
  Date.prototype.getDayName = function(){
    return this.dayNames[this.getDay()];
  };
  Date.prototype.getShortDayName = function(){
    return this.getDayName().substr(0,3);
  };

  var ObjUtil=window.ObjUtil={s4:function(){return Math.floor((1+Math.random())*65536).toString(16).substring(1)},guid:function(s){var t="js";if(s&&s>0){for(var i=0;i<s;i++)t+="js"!==t?"-"+this.s4():this.s4();return t}return"js"+this.s4()+this.s4()+"-"+this.s4()+"-"+this.s4()+"-"+this.s4()+"-"+this.s4()+this.s4()+this.s4()}};
    var Deferred=function(){var t=function(){var t=this;this.promise=new Promise((function(e,r){t.resolve=e,t.reject=r})),this.then=this.promise.then.bind(this.promise),this.catch=this.promise.catch.bind(this.promise)};return t.settlePromises=t.prototype.settlePromises=function(t){var e=t.map((function(t){return t.then((function(t){return{result:t,status:"resolved"}}),(function(t){return{result:t,status:"rejected"}}))}));return Promise.all(e)},t}();
  
    var ResourceLoader = (function(){
      var RESOURCEURL = '/bin/resources.json';

      var Resource = (function(){
        return {
          createScript: function(url){
            var $inject = document.createElement('script');
            var deferredPromise = new Deferred();
            $inject.setAttribute('type','text/javascript');
            $inject.setAttribute('data-type','inject');
            $inject.setAttribute('src', url);
            $inject.ready = deferredPromise.promise;
            $inject.addEventListener('load', function(evt){
              deferredPromise.resolve();
            });   

            return $inject;
          },
          createModule: function(url) {
            var $inject = document.createElement('script');
            var deferredPromise = new Deferred();

            $inject.setAttribute('type','module');
            
            $inject.setAttribute('src', url);
            $inject.ready = deferredPromise.promise;
            console.log('going sending')
            $inject.addEventListener('load', function(evt){
              console.log('resovling')
              deferredPromise.resolve();
            });   

            return $inject;
          },
          createStyle: function(url){
            var $inject = document.createElement('link');
            var deferredPromise = new Deferred();
            $inject.setAttribute('rel','stylesheet');
            $inject.setAttribute('href', url);
            $inject.ready = deferredPromise.promise;
            $inject.addEventListener('load', function(evt){
              deferredPromise.resolve();
            });   

            return $inject;
          }
        }
      })();

      return {
        loadDependencies: function(){
          var def = new Deferred();

          fetch(RESOURCEURL).then(function(resp){
            if(resp.status !== 200){
              throw new Error('Configuration file not found');
            }
            return resp.json();
          }).then(function(resourceJSON){
            return Deferred.settlePromises([
              ResourceLoader.loadURLs(resourceJSON.scriptURLs),
              ResourceLoader.loadStyleURLs(resourceJSON.styleURLs)
            ]);
          }).then(function(results){
            var failed = results.filter(function(r){
              return r.status === 'rejected';
            })[0];
            
            if(failed){
              def.reject(failed.result);
            } else{
              def.resolve();
            }
          });

          return def.promise;
        },
        loadModule: function(url) {
          var $body = document.querySelector('body');
          var res = Resource.createModule(url)
          $body.prepend(res)
          return Deferred.settlePromises([res.ready])
           
        },
        loadURLs: function(urlArr){
          if(!urlArr || !Array.isArray(urlArr)){
            console.error('Invalid resource list');
          }
          var $body = document.querySelector('body');
          var promises = [];
          urlArr.map(function(url){
            return Resource.createScript(url);
          }).forEach(function(res){
            promises.push(res.ready);
            $body.append(res);
          });

          return Deferred.settlePromises(promises);
        },
        loadStyleURLs: function(urlArr){
          if(!urlArr || !Array.isArray(urlArr)){
            console.error('Invalid resource list');
          }
          var promises = [];
          urlArr.forEach(function(url){
            promises.push(ResourceLoader.loadStyleURL(url));
          });

          return Deferred.settlePromises(promises);
        },
        loadStyleURL: function(url){
          var $head = document.head;
          var $inject = Resource.createStyle(url);
          $head.append($inject);
          return $inject.ready;
        },
        loadStyleStr: function(id, str){
          console.log(id, str)
          var $head = document.head;
          var $inject = document.createElement('style');
          $inject.setAttribute('data-type', id);
          $inject.setAttribute('key', id);
          $inject.innerHTML = str;
          $head.append($inject);
          return Promise.resolve();
        }
      }
    })();

  return {
    ResourceLoader: ResourceLoader,
    getCookie: function(key) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + key + "=");
      if (parts.length == 2) {
        return parts.pop().split(";").shift();
      } else{
        return null;
      }
    },
    setCookie: function(key,value,expiryDateObj){
      var expires = "";
      if (expiryDateObj) {
        expires = "; expires=" + expiryDateObj.toGMTString();
      }
      document.cookie = key + "=" + value + expires + "; path=/";
    },
    getURLParam:function(name) {
      name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(window.location.href);
      if (results === null)
        return "";
      else
        return results[1];
    },
    loadImage: function(url){
      var def = new Deferred();
      if(!url){
        return Promise.reject();
      }

      var $body = document.querySelector('body');
      var $img = document.createElement('img');
      $img.style.position = 'absolute';
      $img.style.opacity = 0;
      $img.style.width = '1px';
      $img.style.height = '1px';
      $img.setAttribute('src', url);
      $body.appendChild($img);
      $img.onload = function(){
        $body.removeChild($img);
        def.resolve();
      };

      return def.promise;
    },
    saveAs: function(str, filename){
      str = encodeURIComponent(str);

      var $link = document.createElement('a');
      $link.style.position = 'absolute';
      $link.style.width = '1px';
      $link.style.height = '1px';
      $link.style.opacity = '0';
      
      var $body = document.querySelector('body');
      
      $link.setAttribute('download', filename);
      $link.setAttribute('href', 'data:application/octet-stream,'+ str);

      $body.appendChild($link);

      $link.click();
    }
  };
})();
App.util.Content = (function(){

  var Content = {
    flattenLocales: function(obj){
      var view = this;
      var keys = Object.keys(obj);
      keys.forEach(function(key){
        if(key === 'localizations'){
          var localeObj = obj.localizations && obj.localizations.en?obj.localizations.en:null;
          if(localeObj){
            Object.assign(obj, localeObj);
          }
        } else if(typeof obj[key] === 'object' && !Array.isArray(obj[key])){
          Content.flattenLocales(obj[key]);
        } else if(Array.isArray(obj[key]) && typeof obj[key][0] === 'object'){
          obj[key].forEach(function(o){
            Content.flattenLocales(o);
          });
        }
      });
    }
  };

  return Content;
})();
})(window, document);